<div>

  <sl-label i18n>This will move the selected assignments to the specified date.</sl-label>
  <sl-input label="Move to date" i18n-label [(ngModel)]="date" type="date" class="mt-4" hoist></sl-input>

<div class="footer mt-8">
  <sl-button i18n (click)="cancel()">Cancel</sl-button>
  <sl-button type="danger" i18n (click)="accept()">Move assignments</sl-button>
</div>